import { createContext } from 'react';

const AliasContext = createContext();
export default AliasContext;
